import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/reset.css'
import i18n from 'lang'
import { I18nextProvider } from 'react-i18next'

const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n} defaultNS={'translation'}>
    <App />
  </I18nextProvider>,
  // </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
